import React from 'react';
import { evaluateRules } from '../utils/passwordRules';

// CHECKPOINT-75: live password-rules checklist. Shows a ✓ (met) or ✗ (not met)
// against each active rule as the user types. Shared by the admin Reset/Set
// dialogs and the forced change-password screen. Theme-neutral: green for met,
// muted grey for not-yet-met, so it reads in both light and dark and doesn't look
// alarming before the user has typed anything.
const PasswordRulesHint = ({ rules, password }) => {
    const checks = evaluateRules(password, rules);
    if (!checks.length) return null;

    return (
        <div className="password-rules-hint" style={{ marginTop: 6, marginBottom: 4, fontSize: '0.85rem' }}>
            <div style={{ marginBottom: 4, opacity: 0.85 }}>Password must contain:</div>
            <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                {checks.map((c, i) => (
                    <li key={i} style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2, color: c.met ? '#37b24d' : '#9aa0a6' }}>
                        <span className={`mdi ${c.met ? 'mdi-check-circle' : 'mdi-close-circle-outline'}`} style={{ fontSize: '1rem' }}></span>
                        <span>{c.label}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default PasswordRulesHint;
